
import Notifications, { Notify } from './notifications'
import RedirectComp, { Redirect } from './redirect'
import AlertModalComp from './alert_modal'

export { Notifications as Notification, Notify, RedirectComp, Redirect, AlertModalComp }